import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterAutocomplete_template} from "./filterAutocomplete_template";

declare var ko: any;
declare var Dropzone: any;

export class popupEdit_template extends vnTemplate {

    public filterGEO: filterAutocomplete_template;

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title">Popup</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">                  
                        <input type="checkbox" data-bind="checked: isEnabled" id="is-enabled">
                        <label for="is-enabled" class="form-label icon i-check">Enabled</label>                               
                    </div>
                    <div class="form-group"><hr class="form-hr"></div>
                    <div class="form-group row">
                        <label for="headline" class="form-label form-label form-label-box">Popup Headline</label>
                        <input type="text" class="input-text" data-bind="value: headline">
                    </div>
                    <div class="form-group row">
                        <label for="description" class="form-label form-label form-label-box">Popup Description</label>
                        <input type="text" class="input-text" data-bind="value: description">
                    </div>
                    <div class="form-group row">
                        <label for="signupForm" class="form-label form-label form-label-box">Signup Form</label>
                        <select id="" data-bind="options: availableSignupForms, optionsText: 'label', optionsCaption: 'Select', value: signupForm, optionsValue: 'id', valueAllowUnset: true"></select>
                    </div>
                    <div class="form-group row top">
                        <label for="geos" class="form-label form-label form-label-box">GEOs</label>
                        <div style="margin-left: 14rem">
                            <div class="form-group inside-label" style="margin: 0;">
                                ` + this.filterGEO.getHtmlBuild() + `
                            </div>
                            <div class="form-group" data-bind="foreach: geos" style="width: 530px;margin: -3rem 2rem 0 0">
                                <div class="btn-selection">
                                    <span data-bind="text: name"></span>
                                    <button data-bind="event: {click: $parent.onClickRemoveGeo}" class="icon i-x-after" type="button"></button>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="pageDepth" class="form-label form-label form-label-box">Page Depth for Automatic Display</label>
                        <input type="text" class="input-text" data-bind="value: pageDepth">
                    </div>
                    <div class="form-group">
                       <label class="form-label">Image</label>
                       <div id="dropzone">
                            <div id="my-drop-zone" class="dropzone needsclick dz-clickable"></div>
                            <input id="popup-image" data-bind="value: image" type="hidden">
                       </div>                
                       <div class="form-note">It is recommended to use landscape images with a minimum width of over 1024 pixels.</div>
                    </div>
                </div>
            </div>
            <div class="form-footer">                
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
            </div> 
        `;
    }

    protected initPartial(): void {
        this.filterGEO = new filterAutocomplete_template("filterAutocompleteGEO_template", this.getTemplateViewModel(), this.caller);
        this.filterGEO.setAddNewOptionEnabled(false);
        this.filterGEO.setHasDisplayNameComplement(false);
        this.filterGEO.setIsShowCurrentSelection(false);
        this.filterGEO.setNumberOfChars(1);
        this.filterGEO.setPlaceholderAndLabel("GEO");
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , isEnabled: ko.observable(false)
            , headline: ko.observable("")
            , description: ko.observable("")
            , image: ko.observable(null)
            , signupForm: ko.observable(null)
            , availableSignupForms: ko.observableArray([])
            , geos: ko.observableArray([])
            , pageDepth: ko.observable("")
            , dropzone: ko.observable(null)
            , onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();
            },onClickSave: function (data, event) {
                self.onClickSave()
            },onClickRemoveGeo: function (data) {
                self.onClickRemoveGeo(data)
            }
        }
    }

    protected getTemplateName(): string {
        return "popupEdit_template";
    }

    public setId(id){
        this.getTemplateViewModel().id(id)
    }

    public setIsEnabled(isEnabled){
        this.getTemplateViewModel().isEnabled(isEnabled)
    }

    public setHeadline(headline){
        this.getTemplateViewModel().headline(headline)
    }

    public setDescription(description){
        this.getTemplateViewModel().description(description)
    }

    public setImage(image){
        this.getTemplateViewModel().image(image)
        if(this.getTemplateViewModel().image()) {
            let mockFile = {name: this.getTemplateViewModel().image(), size: parseInt("264560")};
            this.getTemplateViewModel().dropzone().emit("addedfile", mockFile);
            this.getTemplateViewModel().dropzone().createThumbnailFromUrl(mockFile, mockFile.name);
            this.getTemplateViewModel().dropzone().emit("complete", mockFile);
            this.getTemplateViewModel().dropzone().files.push(mockFile);
        }
    }

    public setSignupForm(signupForm){
        this.getTemplateViewModel().signupForm(signupForm)
    }

    public setAvailableSignupForms(availableSignupForms){
        availableSignupForms.sort(function(a,b){
            let a1 = a.label;
            let b1 = b.label;
            return a1.localeCompare(b1);
        });
        this.getTemplateViewModel().availableSignupForms(availableSignupForms)
    }

    public setGeos(geos){
        this.getTemplateViewModel().geos(geos)
    }

    public setPageDepth(pageDepth){
        this.getTemplateViewModel().pageDepth(pageDepth)
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.getTemplateViewModel().dropzone(null);
        this.caller.save()
    }

    protected onClickRemoveGeo(data): any {
        let geos = this.getTemplateViewModel().geos();
        let newGeos = geos.filter((geo) => geo.id != data.id);
        this.getTemplateViewModel().geos(newGeos);
    }

    public generateDropzone(idBrand){
        let url = '/api/brand/' + idBrand + '/popup/uploadImage/';
        let myDropzone = new Dropzone("div#my-drop-zone", { url: url, maxFiles: 1, acceptedFiles: "image/jpeg,image/png,image/gif"});
        this.getTemplateViewModel().dropzone(myDropzone);
        let _this = this;

        myDropzone.on("success", function(file, serverFileName) {
            let responseParsed = serverFileName;
            _this.getTemplateViewModel().image(responseParsed.data);
        });
        myDropzone.on("addedfile", function(file) {
            if (this.files.length > 1) {
                this.removeFile(this.files[0]);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/popupEdit_template.ts